export default "__VITE_ASSET__C7wN0zOu__"